import { tv } from 'tailwind-variants';
import useFetch from 'lib/hooks/useFetch';

import { Icon, SyntaxHighlighter } from '@frontendmentorio/design-system-v2';

const HIGHLIGHT_LANGUAGE = {
  astro: 'jsx',
  hbs: 'handlebars',
  htm: 'html',
  mdx: 'md',
  njk: 'html',
  styl: 'sass',
  svelte: 'html',
  vue: 'html',
};

const styles = tv({
  slots: {
    wrapper: [
      'bg-neutral-50',
      'col-start-1',
      'hidden',
      'items-center',
      'justify-center',
      'min-w-0',
      'row-start-1',
      'w-full',
      'tablet:flex',
      'tablet:h-full',
    ],
    editor: [
      'h-full',
      'max-h-full',
      'mb-auto',
      'min-w-0',
      'w-full',
      '*:block',
      '*:font-[family-name:var(--font-fira-code)]',
      '*:h-full',
      '*:overflow-auto',
      '*:p-3',
      '*:text-sm',
      '[&_.linenumber]:text-neutral-500',
    ],
  },
  variants: {
    isEditorVisible: {
      true: {
        wrapper: ['flex'],
      },
    },
  },
});

const { wrapper, editor } = styles();

export default function Editor({
  isEditorVisible,
  selectedFile,
  setIsEditorVisible,
  solution,
}) {
  const { data: { data } = {}, isLoading } = useFetch(
    selectedFile
      ? `/api/v3/services/repo?url=${solution.repoURL}&entity=${selectedFile?.path}`
      : null
  );

  return (
    <>
      <div className={wrapper({ isEditorVisible })}>
        <button
          className="absolute aspect-square bg-white right-4 rounded-full shadow text-xl top-4 w-[2.5rem] z-10 tablet:hidden"
          onClick={() => setIsEditorVisible(false)}
        >
          <Icon name="xmark" style="solid" />
        </button>

        {isLoading && (
          <Icon
            className="animate-spin text-2xl text-neutral-500"
            name="spinner-third"
          />
        )}

        {data?.content && (
          <pre className="h-full overflow-auto py-2 rounded-lg text-sm w-full *:bg-inherit">
            <SyntaxHighlighter
              className={editor()}
              language={HIGHLIGHT_LANGUAGE[data.extension] || data.extension}
              showLineNumbers={true}
            >
              {atob(data.content)}
            </SyntaxHighlighter>
          </pre>
        )}

        {!data?.content && !isLoading && (
          <span className="text-neutral-500 text-sm">
            {data?.type === 'file' ? 'This file is empty' : 'Select a file'}
          </span>
        )}
      </div>
    </>
  );
}
